import { useMemo } from 'react';
import {
  IJobPostDetailEntity,
  useGetCandidateList,
  useGetJobPostDetail,
} from '~/domain/PermanentJobs';

interface IUseJobOverviewDataReturn {
  jobPosting: IJobPostDetailEntity | undefined;
  hasCandidatesToHire: boolean;
  hasScheduledOnsiteInterviews: boolean;
  isLoading: boolean;
}

export const useJobOverviewData = (postingId?: string): IUseJobOverviewDataReturn => {
  // Fetch job posting detail
  const { data: jobPosting, isLoading: isLoadingJobPosting } = useGetJobPostDetail(postingId);

  // Fetch candidate statistics (limit: 1 for performance since we only need counts)
  const { statistics, isLoading: isLoadingStatistics } = useGetCandidateList(
    {
      jobPostingId: postingId || '',
      limit: 1,
    },
    { enabled: !!postingId, refetchOnWindowFocus: false },
  );

  const hasCandidatesToHire = useMemo(() => {
    return (statistics?.tabs?.interviewed ?? 0) > 0 || (statistics?.tabs?.hired ?? 0) > 0;
  }, [statistics]);

  const hasScheduledOnsiteInterviews = useMemo(() => {
    return (statistics?.tabs?.scheduled ?? 0) > 0;
  }, [statistics]);

  const isLoading = isLoadingJobPosting || isLoadingStatistics;

  return {
    jobPosting,
    hasCandidatesToHire,
    hasScheduledOnsiteInterviews,
    isLoading,
  };
};
